var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('my-terminal',{ref:"myTerminal",attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }